import { Injectable } from "@angular/core";
import { TranslateService } from "ng2-translate";
import { Subject } from "rxjs/Subject";
import { ReplaySubject } from "rxjs/ReplaySubject";
/**
 * Service for sending messages and storing them
 */
export class MessageService {
    constructor(translate) {
        this.translate = translate;
        this._message = new Subject();
        this.message$ = this._message.asObservable();
        this._messages = new ReplaySubject(1);
        this.messages = new Array();
        this.messages$ = this._messages.asObservable();
    }
    /**
     * Remove an existing notification
     * @param {Notification} notification
     */
    complete(id) {
        this.messages.forEach((message) => {
            if (message.id === id) {
                this.messages.splice(this.messages.indexOf(message), 1);
            }
        });
        this._messages.next(this.messages);
    }
    /**
     * Send a new notification
     * @param {string} notification
     */
    send(message) {
        this.translate.get(message.title, { value: message.value }).subscribe((translation) => {
            message.title = translation;
        });
        let found = false;
        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i].id === message.id) {
                this.messages[i] = message;
                found = true;
                break;
            }
        }
        if (!found) {
            this.messages.unshift(message);
        }
        this._messages.next(this.messages);
    }
}
MessageService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
MessageService.ctorParameters = () => [
    { type: TranslateService, },
];
//# sourceMappingURL=message.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/messaging/message.service.js
// module id = null
// module chunks = 